'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dispatcher = require('./dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _events = require('events');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Flux store internally used to manage notifications for material-ui-notifications.
 * 
 * @author Timo Hanisch <timohanisch@googlemail.com>
 * @since 0.1.0
 */
var Store = function (_EventEmitter) {
    _inherits(Store, _EventEmitter);

    function Store() {
        _classCallCheck(this, Store);

        // Ref token returned by Flux
        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this));

        _this._handleActions = function (action) {
            switch (action.type) {
                case _constants.ADD_NOTIFICATION:
                    {
                        _this._addNotification(action.data);
                        break;
                    }
                case _constants.REMOVE_NOTIFICATION:
                    {
                        _this._removeNotification(action.data);
                        break;
                    }
                case _constants.RESET_NOTIFICATIONS:
                    {
                        _this._resetNotifications();
                        break;
                    }
            }
        };

        _this._token = _dispatcher2.default.register(_this._handleActions);
        // List of all active notifications
        _this._notifications = [];
        // List of all timer refs used for auto hide notifcations
        _this._timerRefs = [];
        // Auto increasing id used for added notifications
        _this._uniqueId = 0;
        return _this;
    }

    /**
     * Returns the flux token for this store.
     * Note: Since material-ui-notifications uses its own dispatcher
     * this token might not be usefull at all outside of this library.
     * 
     * @public
     * @returns {String} the token created by flux
     */


    _createClass(Store, [{
        key: '_generateId',


        /**
         * Generates a unique id for a notification. Unique in this store
         * not globally unique.
         * 
         * @private
         */
        value: function _generateId() {
            return this._uniqueId++;
        }

        /**
         * Adds the given notification to the internal notification list and creates
         * a unique id for it. If the notification is an auto hide notification
         * a timer for it is created and added to the internal ref list.
         * Finally a dispatch update is emitted.
         * 
         * @param {*} notification 
         * @private
         */

    }, {
        key: '_addNotification',
        value: function _addNotification(notification) {
            var _this2 = this;

            var autoHide = notification.autoHide,
                rest = _objectWithoutProperties(notification, ['autoHide']);

            var tmpNotification = _extends({}, rest, {
                id: this._generateId()
            });
            this._notifications = [tmpNotification].concat(_toConsumableArray(this._notifications));
            if (autoHide) {
                // Add an object with the notification id and timer ref to the the timer refs
                // list, so we are later properly able to remove it from the timer ref list
                this._timerRefs = [].concat(_toConsumableArray(this._timerRefs), [{
                    id: tmpNotification.id,
                    ref: setTimeout(function () {
                        _this2._removeNotification(tmpNotification.id);
                    }, autoHide)
                }]);
            }
            this.emit(_constants.DISPATCH_UPDATE);
        }

        /**
         * Removes the notification with the given id from the internal notification list.
         * 
         * Finally a dispatch update is emitted.
         * 
         * @param {Number} notificationId 
         * @private
         */

    }, {
        key: '_removeNotification',
        value: function _removeNotification(notificationId) {
            this._notifications = this._notifications.filter(function (notification) {
                return notification.id !== notificationId;
            });
            this._timerRefs = this._timerRefs.filter(function (refObj) {
                return refObj.id !== notificationId;
            });
            this.emit(_constants.DISPATCH_UPDATE);
        }

        /**
         * Stops all timers, removes all notifications from the internal notification list
         * and emits an update event.
         * 
         * @private
         */

    }, {
        key: '_resetNotifications',
        value: function _resetNotifications() {
            this._timerRefs.forEach(function (refObj) {
                clearTimeout(refObj.ref);
            });
            this._timerRefs = [];
            this._notifications = [];
            this.emit(_constants.DISPATCH_UPDATE);
        }

        /**
         * Handle all incoming flux actions dispatched by our dispatcher implementation.
         * 
         * @param {*} action  
         * @private
         */

    }, {
        key: 'token',
        get: function get() {
            return this._token;
        }

        /**
         * Returns the list of all active notifications.
         * 
         * @public
         * @returns {Array<*>}
         */

    }, {
        key: 'notifications',
        get: function get() {
            return this._notifications;
        }
    }]);

    return Store;
}(_events.EventEmitter);

exports.default = new Store();
module.exports = exports['default'];